import React, { FC, JSX } from 'react';
import { Trigger, Validation, ValidationStatus } from '@silverfort/sf-components';
import FormField, { FormFieldsProps } from './FormField';

type ModalFormFieldProps = Omit<FormFieldsProps, 'Input'> & {
    showModal: boolean;
    onClick: () => void;
    selectedLabels?: string[];
    errorMessage?: string;
    Modal: JSX.Element;
};

interface ErrorMessageProps {
    message?: string;
}

const ErrorMessage: FC<ErrorMessageProps> = ({ message }) => {
    if (!message) return null;

    return <Validation className="h-fit" validationStatus={ValidationStatus.Error} text={message} showIcon={false} />;
};

const ModalFormField: FC<ModalFormFieldProps> = ({
    showModal,
    onClick,
    selectedLabels,
    errorMessage,
    Modal,
    ...formFieldProps
}) => {
    const getText = () => {
        if (!selectedLabels?.length) {
            return 'Select';
        }

        if (selectedLabels.length === 1) {
            return selectedLabels[0];
        }

        return `${selectedLabels.length} Selected`;
    };

    return (
        <div className="flex flex-col gap-1">
            <FormField
                {...formFieldProps}
                Input={
                    <>
                        <Trigger className="w-80" text={getText()} onClick={onClick} />
                        {showModal && <div className="absolute inset-0 w-screen h-screen">{Modal}</div>}
                    </>
                }
            />
            {!!errorMessage && (
                <div className="flex justify-end">
                    <div className="w-80">
                        <ErrorMessage message={errorMessage} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default ModalFormField;
